import filter from 'lodash/filter';
import map from 'lodash/map';
import split from 'lodash/split';
import trim from 'lodash/trim';
import { LABELS_FIELD_SEPARATOR } from '../../common/constants';

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
	return Boolean(value);
}
export const toLabels = (content: string | undefined | null): string[] => {
	if (!content) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return [] as string[];
	}
	return filter(map(split(content, LABELS_FIELD_SEPARATOR), trim), notEmpty);
};
